// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailMatch_style_wrapper__z2q0b","error":"DetailMatch_style_error__G5laS","rotate":"DetailMatch_style_rotate__tQVL6"};